import { Table, Row, Col } from "react-bootstrap";
import { UserDataContext } from "../components/UserDataContext";
import { useState, useEffect, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import AddUser from "./AddUser";
import "../components/button.css";
import Button from "@mui/material/Button";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { marginBottom } from "../App";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import Pagination from "@mui/material/Pagination";
import { TextField } from "@mui/material";
import { apiRequest } from "../components/Config";
import FaceIcon from "@mui/icons-material/Face";

export default function PerformersData() {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [showRegister, setShowRegister] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchMode, setSearchMode] = useState(false);
  const [textAdd, setTextAdd] = useState("Dodaj kontrahenta");
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [text, setText] = useState("Pobieranie danych...");
  /*
  useEffect(() => {
    const fetchData = async () => {
      const url = API_URL + `/users/2`;
      try {
        const response = await axios.get(url);
        if (Array.isArray(response)) {
          setData(response);
        } else {
          console.error("Otrzymane dane nie są tablicą:", response.data);
          setData([]);
        }
        console.log("/users: ", response.data);
      } catch (error) {
        //setError(error.message);
      }
    };

    if (userData && userData.userId) {
      fetchData();
    }
  }, [userData]);

  const config = {
    method: "post",
    url: API_URL + `/session`,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
  };
*/
  const fetchData = useCallback(async () => {
    try {
      const response = await apiRequest("search", "POST", {
        param: searchValue,
      });

      if (Array.isArray(response)) {
        setData(response);
        //console.log("kontrahenci1: ", response);
        if (response.length === 0) {
          setText("Brak danych spełniających kryteria wyszukiwania...");
        }
      } else {
        console.error("Otrzymane dane nie są tablicą:", response);
        setData([]);
      }
    } catch (error) {
      //setError(error.message);
      console.log(error.message);
    }
  }, [searchValue]);

  useEffect(() => {
    if (userData) fetchData();
  }, [searchMode, userData, fetchData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest("search", "POST", {
          param: searchValue,
        });
        if (Array.isArray(response)) {
          setData(response);
          //console.log("kontrahenci2: ", response);
        } else {
          console.error("Otrzymane dane nie są tablicą:", response.data);
          setData([]);
        }
        if (response.length === 0)
          setText("Brak danych spełniających kryteria wyszukiwania...");
      } catch (error) {
        //setError(error.message);
      }
    };

    if (userData) fetchData();
  }, [searchMode, userData, searchValue]);

  const handleEditUser = (id) => {
    setShowRegister(false);
    navigate(`/edituser/${id}`);
  };

  const sortedData = [...data].sort((a, b) => {
    if (sortConfig.key === null) return 0;
    const direction = sortConfig.direction === "asc" ? 1 : -1;

    /*
    if (sortConfig.key === "fullName") {
      const aLastName = a.fullName.split(" ")[1] || "";
      const bLastName = b.fullName.split(" ")[1] || "";

      if (aLastName < bLastName) {
        return -1 * direction;
      }
      if (aLastName > bLastName) {
        return 1 * direction;
      }
      return 0;
    } else {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return -1 * direction;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return 1 * direction;
      }
      return 0;
    }
      */
  });

  const paginatedData = sortedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleChangePage = (event, page) => {
    setCurrentPage(page);
  };

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };
  const handleAddUser = () => {
    setShowRegister((prev) => !prev);
    setTextAdd((prev) =>
      prev === "Dodaj kontrahenta"
        ? "Opuść dodawanie kontrahenta"
        : "Dodaj kontrahenta"
    );
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    if (e.target.value.length > 0) {
      setSearchMode(true);
    } else {
      setSearchMode(false);
    }
  };

  return (
    <div>
      {showRegister && <AddUser perm={2} refreshData={fetchData} />}
      <ThemeProvider theme={theme}>
        <Row style={{ marginBottom }}>
          <Col xs={4} sm={3}>
            <Button variant="outlined" onClick={handleAddUser}>
              <FaceIcon /> {textAdd}
            </Button>
          </Col>
          <Col xs={4} sm={3}>
            <h4>Kontrahenci</h4>
          </Col>
          <Col xs={4} sm={3}>
            <TextField
              name="user"
              label="Wyszukaj Kontrahenta"
              variant="outlined"
              onChange={(e) => {
                handleSearch(e);
              }}
              fullWidth
            />
          </Col>
        </Row>
        <Row style={{ marginBottom }}>
          <Pagination
            count={Math.ceil(data.length / itemsPerPage)}
            page={currentPage}
            onChange={handleChangePage}
            color="primary"
            variant="outlined"
            shape="rounded"
          />
        </Row>
      </ThemeProvider>
      <div className="table-responsive">
        <Table bordered hover>
          <thead>
            <tr>
              <th className="td-centered" onClick={() => requestSort("id")}>
                ID
              </th>
              <th onClick={() => requestSort("fullName")}>Kontrahent</th>
              <th onClick={() => requestSort("city")}>Miasto</th>
              <th onClick={() => requestSort("email")}>Email</th>
              <th onClick={() => requestSort("phone")}>Telefon</th>
              <th onClick={() => requestSort("nip")}>NIP</th>
              <th onClick={() => requestSort("regon")}>REGON</th>
              <th onClick={() => requestSort("fullName")}>Osoba kontaktowa</th>
              <th onClick={() => requestSort("expire")}>Ważność konta</th>
              <th className="td-centered">Edycja/Podgląd</th>
            </tr>
          </thead>
          {data.length > 0 && userData.userId ? (
            <tbody>
              {paginatedData.map((item, index) => (
                <tr key={index}>
                  <td className="td-centered">
                    {(currentPage - 1) * itemsPerPage + index + 1}
                  </td>
                  <td>{item.company}</td>
                  <td>{item.city}</td>
                  <td>{item.email}</td>
                  <td className="td-centered">{item.phone}</td>
                  <td className="td-centered">{item.nip}</td>
                  <td className="td-centered">{item.regon}</td>
                  <td className="td-centered">{item.fullName}</td>
                  <td>{item.expire}</td>
                  <td className="td-centered">
                    {item.is_active === "1" ? (
                      <ThemeProvider theme={theme}>
                        <Button
                          variant="outlined"
                          onClick={() => handleEditUser(item.id)}
                        >
                          <i className="fa fa-edit" aria-hidden="true"></i>
                        </Button>
                      </ThemeProvider>
                    ) : (
                      <Button
                        variant="contained"
                        onClick={() => handleEditUser(item.id)}
                      >
                        <i className="fa fa-ban" aria-hidden="true"></i>
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  <h6>{text}</h6>
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </div>
      <Row style={{ marginBottom }}>
        <Pagination
          count={Math.ceil(data.length / itemsPerPage)}
          page={currentPage}
          onChange={handleChangePage}
          color="primary"
          variant="outlined"
          shape="rounded"
        />
      </Row>
    </div>
  );
}
